/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 709
// module chunks = 0